// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.dashboard-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  gap: 10px; 
}



.dashboard-container {
  	color: #333;
	  width: 100%;
    padding: 0px;
     font-size: 15px;
	  font-family: "Roboto", sans-serif;
font-weight: 300;
	padding-bottom: 25px;
}


.dashboard-container p {
  	color: #333;
	  width: 100%;
    padding: 0px;
     font-size: 15px;
	  font-family: "Roboto", sans-serif;
font-weight: 300;
}



.square {
  border-radius: 0px;
	background-color: #ffffff;
	box-shadow: 0 2px 4px 0 rgba(220,220,220,.5);
border: thin #DBDBDB solid;
	overflow: hidden;
	scroll-behavior: auto;
	padding: 15px;
	grid-column: span 1;
}


.square.row-two {
  grid-row: span 2;
}

.square.col-two {
  grid-column: span 2;
}

.square.col-three {
  grid-column: span 3;
}


.dashboard-content-top {
  display: flex;
  align-items: flex-start;
  padding: 0px 0px 20px 0px;
  gap: 0px;
     font-size: 15px;
 font-family: "Roboto", sans-serif;
font-weight: 500;
	z-index: 3;
}


.dashboard-content-table {
  	z-index: 1;
	padding-bottom: 10px;
}


.dashboard-content-top a {
    background-color: #ffffff;
    color: #0028ff;
    padding: 5px 8px;
    border-radius: 5px;
    border: 1px solid #ffffff;
	transition: background-color 0.3s, color 0.3s;
    cursor: pointer;
	font-size: 15px;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    letter-spacing: normal;
	margin-left: 5px;
}

.dashboard-content-top a:hover {
    background-color: #e6e6e6;
	border: 1px solid #d3d3d3;
	color: #333;
}


.dashboard-content-top > div:first-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 150px);
	text-align: left;
}

.dashboard-content-top > div:nth-child(2) {
   flex: 0 0 150px;
  text-align: right;
}




.dashboard-content-header, .dashboard-content-item {
  display: flex;
  align-items: flex-start;
  padding: 8px 0px;
  gap: 10px;
	  border-bottom: 1px solid #ccc;

}


.dashboard-content-item:hover
{
	background-color: #F5F5F5;
}

.dashboard-content-header {
 	color: #0028ff;
     font-size: 15px;
	  font-family: "Roboto", sans-serif;
font-weight: 500;
}


.dashboard-content-header > .header-item:first-child,
.dashboard-content-item > div:first-child {
  flex: 0 0 15px;
}

.dashboard-content-header > .header-item:nth-child(2),
.dashboard-content-item > div:nth-child(2) {
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: calc(100% - 210px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dashboard-content-header > .header-item:nth-child(3),
.dashboard-content-item > div:nth-child(3) {
  flex: 0 0 110px;
	  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dashboard-content-header > .header-item:nth-child(4),
.dashboard-content-item > div:nth-child(4)
 {
  flex: 0 0 60px;
	   text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}





.dashboard-createdcontent-header, .dashboard-createdcontent-item {
  display: flex;
  align-items: flex-start;
  padding: 8px 0px;
  gap: 10px;
	  border-bottom: 1px solid #ccc;

}


.dashboard-createdcontent-item:hover
{
	background-color: #F5F5F5;
}

.dashboard-createdcontent-header {
 	color: #0028ff;
     font-size: 15px;
	  font-family: "Roboto", sans-serif;
font-weight: 500;
}


.dashboard-createdcontent-header > .header-item:first-child,
.dashboard-createdcontent-item > div:first-child {
   flex-grow: 0;
   flex-shrink: 0;
   flex-basis: calc(100% - 80px);
	text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dashboard-createdcontent-header > .header-item:nth-child(2){
   flex: 0 0 120px;

}

.dashboard-createdcontent-item > div:nth-child(2) {
   flex: 0 0 80px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dashboard-createdcontent-header > .header-item:nth-child(3),
.dashboard-createdcontent-item > div:nth-child(3) {
  flex: 0 0 80px;
}

.dashboard-createdcontent-header > .header-item:nth-child(4),
.dashboard-createdcontent-item > div:nth-child(4)
 {
  flex: 0 0 60px;
}



.dashboard-two {
  display: flex;
  align-items: flex-start;
  padding: 8px 0px;
	width: 100%;
  gap: 10px;
	  border-bottom: 1px solid #ccc;

}


.dashboard-two:hover
{
	background-color: #F5F5F5;
}


.dashboard-two > div:first-child {
  flex: 0 0 50%;
	  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}



.dashboard-two > div:nth-child(2) {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
	  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}



.gauge {
margin-top: -30px;
}


.bargraph {

}


.big-font p {
	font-size: 18px;
}

tspan {
 	color: #0028ff;
     font-size: 13px;
	  font-family: "Roboto", sans-serif;
font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/Dashboard.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,aAAa;EACb,qCAAqC;;EAErC,SAAS;AACX;;;;AAIA;GACG,WAAW;GACX,WAAW;IACV,YAAY;KACX,eAAe;GACjB,iCAAiC;AACpC,gBAAgB;CACf,oBAAoB;AACrB;;;AAGA;GACG,WAAW;GACX,WAAW;IACV,YAAY;KACX,eAAe;GACjB,iCAAiC;AACpC,gBAAgB;AAChB;;;;AAIA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,4CAA4C;AAC7C,0BAA0B;CACzB,gBAAgB;CAChB,qBAAqB;CACrB,aAAa;CACb,mBAAmB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,QAAQ;KACL,eAAe;CACnB,iCAAiC;AAClC,gBAAgB;CACf,UAAU;AACX;;;AAGA;GACG,UAAU;CACZ,oBAAoB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;CAC5B,6CAA6C;IAC1C,eAAe;CAClB,eAAe;IACZ,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;CACzB,gBAAgB;AACjB;;AAEA;IACI,yBAAyB;CAC5B,yBAAyB;CACzB,WAAW;AACZ;;;AAGA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;CAC7B,gBAAgB;AACjB;;AAEA;GACG,eAAe;EAChB,iBAAiB;AACnB;;;;;AAKA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;GACR,6BAA6B;;AAEhC;;;AAGA;;CAEC,yBAAyB;AAC1B;;AAEA;EACE,cAAc;KACX,eAAe;GACjB,iCAAiC;AACpC,gBAAgB;AAChB;;;AAGA;;EAEE,cAAc;AAChB;;AAEA;;GAEG,YAA4B;GAA5B,cAA4B;GAA5B,8BAA4B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;GACd,uBAAuB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;IACZ,uBAAuB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;;;;;AAMA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;GACR,6BAA6B;;AAEhC;;;AAGA;;CAEC,yBAAyB;AAC1B;;AAEA;EACE,cAAc;KACX,eAAe;GACjB,iCAAiC;AACpC,gBAAgB;AAChB;;;AAGA;;GAEG,YAA2B;GAA3B,cAA2B;GAA3B,6BAA2B;CAC7B,uBAAuB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;GACG,eAAe;;AAElB;;AAEA;GACG,cAAc;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;CACjB,WAAW;EACV,SAAS;GACR,6BAA6B;;AAEhC;;;AAGA;;CAEC,yBAAyB;AAC1B;;;AAGA;EACE,aAAa;GACZ,uBAAuB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;GACzB,uBAAuB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA;AACA,iBAAiB;AACjB;;;AAGA;;AAEA;;;AAGA;CACC,eAAe;AAChB;;AAEA;EACE,cAAc;KACX,eAAe;GACjB,iCAAiC;AACpC,gBAAgB;AAChB","sourcesContent":["@charset \"utf-8\";\n\n.dashboard-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n\n  gap: 10px; \n}\n\n\n\n.dashboard-container {\n  \tcolor: #333;\n\t  width: 100%;\n    padding: 0px;\n     font-size: 15px;\n\t  font-family: \"Roboto\", sans-serif;\nfont-weight: 300;\n\tpadding-bottom: 25px;\n}\n\n\n.dashboard-container p {\n  \tcolor: #333;\n\t  width: 100%;\n    padding: 0px;\n     font-size: 15px;\n\t  font-family: \"Roboto\", sans-serif;\nfont-weight: 300;\n}\n\n\n\n.square {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\tbox-shadow: 0 2px 4px 0 rgba(220,220,220,.5);\nborder: thin #DBDBDB solid;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n\tpadding: 15px;\n\tgrid-column: span 1;\n}\n\n\n.square.row-two {\n  grid-row: span 2;\n}\n\n.square.col-two {\n  grid-column: span 2;\n}\n\n.square.col-three {\n  grid-column: span 3;\n}\n\n\n.dashboard-content-top {\n  display: flex;\n  align-items: flex-start;\n  padding: 0px 0px 20px 0px;\n  gap: 0px;\n     font-size: 15px;\n font-family: \"Roboto\", sans-serif;\nfont-weight: 500;\n\tz-index: 3;\n}\n\n\n.dashboard-content-table {\n  \tz-index: 1;\n\tpadding-bottom: 10px;\n}\n\n\n.dashboard-content-top a {\n    background-color: #ffffff;\n    color: #0028ff;\n    padding: 5px 8px;\n    border-radius: 5px;\n    border: 1px solid #ffffff;\n\ttransition: background-color 0.3s, color 0.3s;\n    cursor: pointer;\n\tfont-size: 15px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 300;\n    letter-spacing: normal;\n\tmargin-left: 5px;\n}\n\n.dashboard-content-top a:hover {\n    background-color: #e6e6e6;\n\tborder: 1px solid #d3d3d3;\n\tcolor: #333;\n}\n\n\n.dashboard-content-top > div:first-child {\n  flex: 0 0 calc(100% - 150px);\n\ttext-align: left;\n}\n\n.dashboard-content-top > div:nth-child(2) {\n   flex: 0 0 150px;\n  text-align: right;\n}\n\n\n\n\n.dashboard-content-header, .dashboard-content-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px 0px;\n  gap: 10px;\n\t  border-bottom: 1px solid #ccc;\n\n}\n\n\n.dashboard-content-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.dashboard-content-header {\n \tcolor: #0028ff;\n     font-size: 15px;\n\t  font-family: \"Roboto\", sans-serif;\nfont-weight: 500;\n}\n\n\n.dashboard-content-header > .header-item:first-child,\n.dashboard-content-item > div:first-child {\n  flex: 0 0 15px;\n}\n\n.dashboard-content-header > .header-item:nth-child(2),\n.dashboard-content-item > div:nth-child(2) {\n   flex: 0 0 calc(100% - 210px);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.dashboard-content-header > .header-item:nth-child(3),\n.dashboard-content-item > div:nth-child(3) {\n  flex: 0 0 110px;\n\t  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.dashboard-content-header > .header-item:nth-child(4),\n.dashboard-content-item > div:nth-child(4)\n {\n  flex: 0 0 60px;\n\t   text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n\n\n\n\n.dashboard-createdcontent-header, .dashboard-createdcontent-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px 0px;\n  gap: 10px;\n\t  border-bottom: 1px solid #ccc;\n\n}\n\n\n.dashboard-createdcontent-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.dashboard-createdcontent-header {\n \tcolor: #0028ff;\n     font-size: 15px;\n\t  font-family: \"Roboto\", sans-serif;\nfont-weight: 500;\n}\n\n\n.dashboard-createdcontent-header > .header-item:first-child,\n.dashboard-createdcontent-item > div:first-child {\n   flex: 0 0 calc(100% - 80px);\n\ttext-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.dashboard-createdcontent-header > .header-item:nth-child(2){\n   flex: 0 0 120px;\n\n}\n\n.dashboard-createdcontent-item > div:nth-child(2) {\n   flex: 0 0 80px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.dashboard-createdcontent-header > .header-item:nth-child(3),\n.dashboard-createdcontent-item > div:nth-child(3) {\n  flex: 0 0 80px;\n}\n\n.dashboard-createdcontent-header > .header-item:nth-child(4),\n.dashboard-createdcontent-item > div:nth-child(4)\n {\n  flex: 0 0 60px;\n}\n\n\n\n.dashboard-two {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px 0px;\n\twidth: 100%;\n  gap: 10px;\n\t  border-bottom: 1px solid #ccc;\n\n}\n\n\n.dashboard-two:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n\n.dashboard-two > div:first-child {\n  flex: 0 0 50%;\n\t  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n\n\n.dashboard-two > div:nth-child(2) {\n  flex: 0 0 calc(50% - 10px);\n\t  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n\n\n.gauge {\nmargin-top: -30px;\n}\n\n\n.bargraph {\n\n}\n\n\n.big-font p {\n\tfont-size: 18px;\n}\n\ntspan {\n \tcolor: #0028ff;\n     font-size: 13px;\n\t  font-family: \"Roboto\", sans-serif;\nfont-weight: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
